<template>
  <div>
    <HttpContentView :endpoint="utilities.path('communities/@/modules/automation/templates/@', communityId, templateKey)" @response="template = $event">
      <template v-slot:content>
        <HttpFormView v-if="config" :endpoint="utilities.path('communities/@/modules/automation/rules', communityId)" method="post" :content="template?.content" @success="emit('success')">
          <template v-slot:form="{ content, errors, submit, loading }">
            <InputView type="text" v-model:value="content.name" :max="32" class="mb-4" :title="translate('automation.rule_name')" :errors="errors.name" required/>
            <div class="d-flex flex-column g-4 mb-4">
              <div v-for="(action, index) in filteredActions" :key="index">
                <TemplateActionForm v-if="content.actions && content.actions[index]" :community-id="communityId" :config="config" :explanation="action.explanation" :value="content.actions[index]" :trigger="trigger" @update:value="content.actions[index] = $event" :data-types="config.dataTypes" :errors="errors.actions ? errors.actions[index] : undefined"/>
              </div>
            </div>
            <div class="d-flex align-items-center g-4">
              <ButtonView type="normal" color="primary" class="w-100" @click="submit">
                {{ translate('automation.create_rule') }}
              </ButtonView>
              <ButtonView type="normal" color="secondary" class="w-100" @click="emit('cancel')">
                {{ translate("cancel") }}
              </ButtonView>
            </div>
            <SpinnerView color="primary" :active="loading"/>
          </template>
        </HttpFormView>
      </template>
    </HttpContentView>
  </div>
</template>

<script setup>
import {computed, onMounted, ref} from "vue";
import axios from "axios";
import {toasts, utilities, HttpContentView, ButtonView, HttpFormView, SpinnerView, InputView} from "@niftybit/vue";
import TemplateActionForm from "@/systems/modules/automation/templates/TemplateActionForm.vue";

const props = defineProps({
  communityId: String,
  templateKey: String
});

const emit = defineEmits(["success", "cancel"]);

const config = ref(undefined);
const template = ref(undefined);


onMounted(() => {
  axios.get(utilities.path("communities/@/modules/automation/config", props.communityId)).then(response => {
    config.value = response.data;
  }).catch(response => {
    toasts.create({
      color: "danger",
      content: "Failed to load automation configuration (" + response.status + ")."
    });
  });
});

const filteredActions = computed(() => template.value?.content.actions.filter(item => item.parameters && Object.values(item.parameters).includes(null)));

const trigger = computed(() => template.value?.content?.triggerKey && config.value?.triggers ? config.value?.triggers.find(item => item.key === template.value?.content.triggerKey) : undefined);

</script>